import request from '../utils/request';
import { API_PATHS } from './config';

const { FUND } = API_PATHS;

const buildQuery = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== '') {
            qs.set(key, String(value));
        }
    });
    const str = qs.toString();
    return str ? `?${str}` : '';
};

/** 我的关注列表（对接文档 §17.3） */
export const listWatchlist = async () => {
    const data = await request(FUND.WATCHLIST, { method: 'GET' });
    return Array.isArray(data) ? data : [];
};

/** 加入关注；无档案时创建占位「待同步」 */
export const addWatchlist = (code) =>
    request(`${FUND.WATCHLIST_ADD}/${encodeURIComponent(code)}`, { method: 'POST' });

/** 移出关注 */
export const removeWatchlist = (code) =>
    request(`${FUND.WATCHLIST_REMOVE}/${encodeURIComponent(code)}`, { method: 'POST' });

/** 基金详情（仅自选内基金） */
export const getFundDetail = (code) =>
    request(`${FUND.DETAIL}/${encodeURIComponent(code)}`, { method: 'GET' });

/** 净值序列（仅自选内基金） */
export const getFundNav = (code, { startDate, endDate } = {}) =>
    request(
        `${FUND.NAV}/${encodeURIComponent(code)}/nav${buildQuery({ startDate, endDate })}`,
        { method: 'GET' }
    ).then((data) => (Array.isArray(data) ? data : []));

/** 季报重仓（仅自选内基金） */
export const getFundHoldings = (code, { reportDate } = {}) =>
    request(
        `${FUND.HOLDINGS}/${encodeURIComponent(code)}/holdings${buildQuery({ reportDate })}`,
        { method: 'GET' }
    );

/** 持仓历史（仅自选内基金） */
export const getFundHoldingsHistory = (code) =>
    request(`${FUND.HOLDINGS_HISTORY}/${encodeURIComponent(code)}/holdings/history`, {
        method: 'GET',
    }).then((data) => (Array.isArray(data) ? data : []));

/** 行业配置（仅自选内基金） */
export const getFundSectors = (code, { reportDate } = {}) =>
    request(
        `${FUND.SECTORS}/${encodeURIComponent(code)}/sectors${buildQuery({ reportDate })}`,
        { method: 'GET' }
    );

/** 关联资讯（仅自选内基金） */
export const getFundNews = (code, { limit = 20 } = {}) =>
    request(
        `${FUND.NEWS}/${encodeURIComponent(code)}/news${buildQuery({ limit })}`,
        { method: 'GET' }
    ).then((data) => (Array.isArray(data) ? data : []));

/** 自选对比；codes 须均在关注列表内 */
export const compareFunds = (codes, { startDate, endDate } = {}) => {
    const codeStr = Array.isArray(codes) ? codes.join(',') : codes;
    return request(
        `${FUND.COMPARE}${buildQuery({ codes: codeStr, startDate, endDate })}`,
        { method: 'GET' }
    );
};

/** Agent 收件箱 */
export const listAgentInbox = ({ readFlag, page = 1, size = 20 } = {}) =>
    request(`${FUND.AGENT_INBOX}${buildQuery({ readFlag, page, size })}`, { method: 'GET' });

/** 标记收件箱已读 */
export const markAgentInboxRead = (id) =>
    request(`${FUND.AGENT_INBOX_READ}/${id}/read`, { method: 'POST' });
